import { AccredibleDesign } from '@accredible-frontend-v2/models';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DesignsListParams, DesignsListResponse } from '../../entities/design.model';
import { DashboardApiService } from '../db-api.service';

const DESIGN_API_ENDPOINT = '/v1/design';
const API_ENDPOINT = '/v1/issuer/organizations';

@Injectable({
  providedIn: 'root',
})
export class DesignsApiService extends DashboardApiService {
  protected override _getHeaders(method: string, endpoint: string): { [header: string]: string } {
    const headers = super._getHeaders(method, endpoint);
    return {
      ...headers,
      'accredible-department-id': this.embedding.departmentId.toString(),
    };
  }

  loadDesign(id: number): Observable<AccredibleDesign> {
    const url = `${DESIGN_API_ENDPOINT}/${id}`;

    return this._get(url).pipe(
      map((res) => this._handleResponse(res, 'design')),
      catchError((res) => this._handleError(res)),
    );
  }

  loadDesigns(params: DesignsListParams): Observable<DesignsListResponse> {
    const url = `${API_ENDPOINT}/${this.embedding.departmentId}/designs/search`;

    const nonNullParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== null),
    );

    return this._post(url, nonNullParams).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res)),
    );
  }

  loadStaticDesigns(params: DesignsListParams): Observable<DesignsListResponse> {
    const url = '/v1/organization/static_designs';

    return this._post(url, params).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res)),
    );
  }
}
